module.exports = __webpack_public_path__ + "static/media/imagem12.e0600c46.jpeg";